import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAktuelleRechnungsnummerMutation, useSetAktuelleRechnungsnummerMutation } from '../../api/FakturaAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

export default function RechnungsnummerAnpassen() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [getAktuelleRechnungsnummerAPI] = useGetAktuelleRechnungsnummerMutation();
    const [setAktuelleRechnungsnummerAPI] = useSetAktuelleRechnungsnummerMutation();

    const [aktuelleRgnr, setAktuelleRgnr] = useState<number | undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const refreshAktuelleRechnungsnr = () => {
        setIsLoading(true);
        getAktuelleRechnungsnummerAPI("").unwrap()
            .then((data) => setAktuelleRgnr(data))
            .catch((error) => console.log(error))
            .finally(() => setIsLoading(false))
            ;
    }

    const speichern = (e: { preventDefault: () => void; target: any; }) => {
        e.preventDefault();

        if (aktuelleRgnr===undefined) return;
        
        setIsLoading(true);
        setAktuelleRechnungsnummerAPI({ kennung: "", neueRechnungsnummer: aktuelleRgnr }).unwrap()
            .catch((error) => console.log(error))
            .finally(() => setIsLoading(false))
            ;
    }

    useEffect(() => {
        refreshAktuelleRechnungsnr();
    }, []);

    return (
        <>
            <div>

                <LandingpageHeader />

                <LoadingModal show={isLoading} />

                <div style={{ padding: "20px" }}>

                    <div className="container">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => {
                                    navigate({
                                        pathname: "/",
                                        search: ""
                                    });
                                }}

                                style={{ marginBottom: "20px" }}
                                className=' btn btn-outline-primary'
                            >
                                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                            </button>
                        </div>

                        <h3>Rechnungsnummer anpassen</h3>

                        <pre>
                            Achtung! Bitte seien Sie sorgfältig beim Setzen einer neuen Rechnungsnummer. Es wird nicht geprüft, ob
                            bereits Rechnungen mit dieser Nummer existieren.
                        </pre>

                        <form onSubmit={speichern}>
                            <div className="form-group">
                                Aktuelle Rechnungsnummer:
                                <input className='form-control' name="auftraggeber" value={aktuelleRgnr} onChange={(e) => setAktuelleRgnr(Number.parseInt(e.target.value))} />
                            </div>

                            <div className="form-group">
                                <input type="submit" className='btn btn-primary' value="Speichern" />
                            </div>
                        </form>

                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}
